export default [
  {
    path: '*',
    name: 'error-404',
    component: () => import('./views/pages/404.vue'),
  },
  {
    path: '/_admin/processes',
    alias: '/_hostadmin/processes',
    name: 'processes',
    component: () => import('./views/pages/_admin/processes/index.vue'),
  },
  {
    path: '/_admin/sequencenumbers',
    alias: '/_hostadmin/sequencenumbers',
    name: 'sequencenumbers',
    component: () => import('./views/pages/_admin/sequenceNumbers/list.vue'),
  },
  {
    path: '/_admin/contactidmapping',
    alias: '/_hostadmin/contactidmapping',
    name: 'contactidmapping',
    component: () => import('./views/pages/_admin/contactIdMapping/index.vue'),
  },
  {
    path: '/_admin/contactidmapping/:id',
    alias: '/_hostadmin/contactidmapping/:id',
    name: 'contactidmapping-detail',
    component: () => import('./views/pages/_admin/contactIdMapping/edit.vue'),
  },
  {
    path: '/_admin/integrationlog',
    alias: '/_hostadmin/integrationlog',
    name: 'integrationlog',
    component: () => import('./views/pages/_admin/integrationLog/integrationlog.vue'),
  },
  {
    path: '/_admin/integrationlog/:id',
    alias: '/_hostadmin/integrationlog/:id',
    name: 'integration-detail',
    component: () => import('./views/pages/_admin/integrationLog/integrationDetail.vue'),
  },
  {
    path: '/_admin/fieldmapping',
    alias: '/_hostadmin/fieldmapping',
    name: 'fieldmapping',
    component: () => import('./views/pages/_admin/fieldMapping/index.vue'),
  },
  {
    path: '/_admin/applog',
    alias: '/_hostadmin/applog',
    name: 'hostadmin-applogs',
    component: () => import('./views/pages/_admin/applog.vue'),
  },
  {
    path: '/_admin/users',
    alias: '/_hostadmin/users',
    name: 'hostadmin-users',
    component: () => import('./views/pages/_admin/users.vue'),
  },
  {
    path: '/_admin/users/create',
    alias: '/_hostadmin/users/create',
    name: 'hostadmin-createuser',
    component: () => import('./views/pages/_admin/createUser.vue'),
  },
  {
    path: '/_admin/users/:id',
    alias: '/_hostadmin/users/:id',
    name: 'hostadmin-userdetail',
    component: () => import('./views/pages/_admin/userDetail.vue'),
  },
  {
    path: '/_admin/dashboard',
    alias: '/_hostadmin/dashboard',
    name: 'hostadmin-dashboard',
    component: () => import('./views/pages/_admin/dashboard.vue'),
  },
  {
    path: '/_admin/',
    alias: '/_hostadmin',
    name: 'hostadmin-index',
    component: () => import('./views/pages/_admin/index.vue'),
  },
  {
    path: '/_exterior/qr',
    name: 'qr-entry',
    component: () => import('./views/pages/_exterior/qr-entry.vue'),
  },
  {
    path: '/_exterior/login',
    name: 'login',
    component: () => import('./views/pages/_exterior/login.vue'),
  },
  {
    path: '/_exterior/register',
    name: 'registration',
    component: () => import('./views/pages/_exterior/registration.vue'),
  },
  {
    path: '/_exterior/verify-user/',
    name: 'verify-user',
    component: () => import('./views/pages/_exterior/verify-user.vue'),
  },
  {
    path: '/_me/profile',
    name: 'profile',
    component: () => import('./views/pages/_me/profile.vue'),
  },
  {
    path: '/_exterior/reset-password/',
    name: 'reset-password',
    component: () => import('./views/pages/_exterior/reset-password.vue'),
  },
  {
    path: '/_exterior/confirm-new-password',
    name: 'confirm-new-password',
    component: () => import('./views/pages/_exterior/confirm-new-password.vue'),
  },
  {
    path: '/_exterior/confirm-new-password/:email',
    name: 'confirm-new-password-email',
    component: () => import('./views/pages/_exterior/confirm-new-password.vue'),
  },
];
